<template>
	<article id="general-tab" class="info general-tab">
		<ManagingSection size="l">
			<ManagingBox title="회원상태">{{ registerStatus }}</ManagingBox>
			<ManagingBox title="회원등급">
				<RadioList
					v-model="info.grade"
					:radio-list="gradeList"
					value-name="name"
					@inputWithOptional="changeGrade"
				/>
			</ManagingBox>
			<ManagingBox title="블라인드 여부">
				<RadioList
					v-model="info.isBlind"
					value-name="name"
					:radio-list="isBlindList"
					:disabled-ids="[2]"
					:disabled="true"
					@inputWithOptional="changeIsBlind"
				/>
			</ManagingBox>
			<ManagingBox title="리뷰 피신고건수">{{
				info.reportedReviewsTotal
			}}</ManagingBox>
			<ManagingBox title="중복회원">
				<button
					v-if="sameRegistersTotal"
					class="btn blue"
					type="button"
					@click="toggleSameRegisterModal"
				>
					{{ sameRegistersTotal }}명 리스트 보기
				</button>
			</ManagingBox>
			<ManagingBox title="회원번호">
				<b>{{ idRegister }}</b>
			</ManagingBox>
			<ManagingBox title="닉네임" :is-block-box="true">
				<b>{{ info.nickname }}</b>
				<button
					class="btn blue info__btn-nickname-history"
					type="button"
					@click="showNicknameHistory"
				>
					변경이력
				</button>
			</ManagingBox>
			<ManagingBox title="가입일">{{ info.createDate }}</ManagingBox>
			<ManagingBox title="최근접속일">{{ info.lastDate }}</ManagingBox>
			<ManagingBox title="SNS 연동">{{ info.sns }}</ManagingBox>
			<ManagingBox title="사진">
				<button
					class="info__profile"
					type="button"
					@click="showOriginImg(info.profileImgSrc)"
				>
					<ProfileImg
						:src="info.profileImgSrc"
						class="info__profile__img"
					/>
					<p v-if="info.profileImgSrc" class="info__profile__name">
						{{ info.fileSaveName }}
					</p>
				</button>
			</ManagingBox>
			<ManagingBox title="이메일">
				<div class="info__email">
					<input
						v-if="emailModifyActive"
						v-model="emailInput"
						class="form-sm"
						type="text"
					/>
					<p v-else class="info__email__text">{{ info.email }}</p>
					<button
						:class="[
							'btn info__email__change-btn',
							{
								blue: emailModifyActive,
							},
						]"
						@click="changeEmail(emailModifyActive)"
					>
						{{ emailModifyActive ? '수정' : '변경' }}
					</button>
				</div>
			</ManagingBox>
			<ManagingBox title="성별">{{ info.gender }}</ManagingBox>
			<ManagingBox title="나이">{{ age }}</ManagingBox>
			<ManagingBox title="피부타입">{{ info.skinType }}</ManagingBox>
			<ManagingBox title="픽플여부">
				<RadioList
					v-model="info.isPickple"
					:radio-list="isPickpleList"
					@inputWithOptional="changeIsPickple"
				/>
			</ManagingBox>
			<ManagingBox title="뷰티 프로필">
				<table class="table-main">
					<thead>
						<tr>
							<th>뷰티 프로필 공개 여부</th>
							<th
								v-for="item in beautyProfileTypeList"
								:key="item.type"
								v-text="item.type"
							/>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>
								{{
									info.isBeautyProfileVisible === true
										? '공개'
										: '비공개'
								}}
							</td>
							<td
								v-for="item in beautyProfileTypeList"
								:key="item.type"
								v-text="
									beautyProfileTitleFromIdList(
										info.beautyProfileList,
										item.type
									)
								"
							/>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
			<!-- 앱 인스타연동 지원전 임시 코드 -->
			<ManagingBox
				v-if="$store.state.env.NODE_ENV === 'production'"
				title="인스타그램"
			>
				<div class="general-tab__insta-wrapper">
					<input
						v-model="insta"
						placeholder="인스타그램 주소를 입력하세요. (클릭 시 아웃 랜딩)"
						type="text"
						class="general-tab__insta-input"
					/>
					<button
						class="btn general-tab__insta-button"
						v-text="hasInsta ? '수정' : '입력'"
						@click="instaInput"
					/>
					<button
						v-if="hasInsta"
						class="btn red general-tab__insta-button"
						v-text="'삭제'"
						@click="instaDelete"
					/>
					<button
						class="btn blue info__btn-insta-history"
						@click="showInstaHistory"
					>
						변경이력
					</button>
					<p v-if="hasInsta" class="general-tab__insta-desc">
						등록된 주소:
						<a
							:href="originInsta"
							target="_blank"
							v-text="originInsta"
						/>
					</p>
					<p class="general-tab__insta-desc">
						주소 예시:
						<a
							href="https://www.instagram.com/glowpick/"
							target="_blank"
							v-text="'https://www.instagram.com/glowpick/'"
						/>
					</p>
				</div>
			</ManagingBox>
			<ManagingBox v-else title="인스타그램" :horizontalMode="true">
				<b
					:class="instaStatus === '연동' ? 'color-green' : 'font-red'"
					v-text="instaStatus"
				/>
				<a
					v-if="instaUrl"
					:href="instaUrl"
					target="_blank"
					class="general-tab__insta-url"
					v-text="instaUrl"
				/>
				<button
					class="btn blue info__btn-insta-history"
					@click="showInstaHistory"
				>
					변경이력
				</button>
			</ManagingBox>
			<!-- 앱 인스타연동 지원전 임시 코드 -->
			<ManagingBox title="인스타그램 카테고리">
				<RadioList
					:value="instaCate"
					:radioList="$store.state.filter.instaCateList"
					valueName="txt"
					:disabled="hasInsta ? false : 'all'"
					@input="instaCateInput"
				/>
			</ManagingBox>
			<ManagingBox title="단말관련정보">{{ getFcmToken }}</ManagingBox>
			<ManagingBox v-if="hasAuthority" title="배송지 정보">
				<table class="simple-table info__add-profile-table">
					<thead>
						<tr>
							<th>이름</th>
							<th>휴대폰 번호</th>
							<th>주소</th>
							<th class="info__add-profile-table__btn-cell">
								변경이력
							</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>{{ info.userName }}</td>
							<td>
								<p class="info__add-profile-table__is-cert">
									<PhoneNumber :tel="info.userTel" />
									<IsCertification
										:is-certification="info.isCertification"
									/>
								</p>
							</td>
							<td>{{ info.userAddress }}</td>
							<td class="info__add-profile-table__btn-cell">
								<button
									class="btn blue"
									type="button"
									@click="showAddProfileHistory"
								>
									보기
								</button>
							</td>
						</tr>
					</tbody>
				</table>
			</ManagingBox>
			<ManagingBox title="기타정보">
				<RegisterEtcInfo
					:id-register="Number(idRegister)"
					:nickname="info.nickname"
				/>
			</ManagingBox>
			<ManagingBox title="이벤트 당첨수">{{ eventWinTotal }}</ManagingBox>
			<ManagingBox :title="`이벤트 참여(${eventTotal})`">
				<div class="info__table__scroller" v-if="eventTotal > 0">
					<table class="table table-main info__table">
						<thead>
							<tr>
								<th>#</th>
								<th>클라이언트</th>
								<th>이벤트명</th>
								<th>이벤트ID</th>
								<th>이벤트 시작일시</th>
								<th>참여일시</th>
								<th>구 이벤트 여부</th>
								<th>당첨여부</th>
								<th>취소</th>
							</tr>
						</thead>
						<tbody>
							<tr
								v-for="(item, idx) in eventList"
								:key="item.idAdminBoard"
								:style="
									item.isWin
										? { backgroundColor: '#FFFACD' }
										: ''
								"
							>
								<td>{{ idx + 1 }}</td>
								<td>{{ item.brandTitle }}</td>
								<td>{{ item.boardTitle }}</td>
								<td class="white-space__nowrap">
									{{ item.idAdminBoard }}
								</td>
								<td class="white-space__nowrap">
									{{ item.startDate[0] }}<br />{{
										item.startDate[1]
									}}
								</td>
								<td class="white-space__nowrap">
									{{ item.createDate[0] }}<br />{{
										item.createDate[1]
									}}
								</td>
								<td>{{ item.idOldEvent }}</td>
								<td>
									<i
										class="fa fa-check info__event-win-icon--win"
										aria-hidden="true"
										v-if="item.isWin"
									></i>
									<i
										class="fa fa-times info__event-win-icon"
										aria-hidden="true"
										v-else
									></i>
								</td>
								<td>
									<button
										class="btn info__table-cancel-btn"
										type="button"
										v-if="item.cancelEvent"
										@click="cancelEvent(item.idAdminBoard)"
									>
										취소
									</button>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</ManagingBox>
			<ManagingBox title="비밀번호 초기화 URL">
				<div class="info__pw-init">
					<button
						class="btn blue"
						type="button"
						@click="createdPWInitUrl"
					>
						초기화 URL 생성
					</button>
					<template v-if="pwInitShortUrl">
						<span class="info__pw-init-info"
							>생성URL: {{ pwInitShortUrl }}</span
						>
						<span class="info__pw-init-info"
							>생성시간: {{ pwInitCreated }}</span
						>
						<span class="info__pw-init-info"
							>만료시간: {{ pwInitEnd }}</span
						>
					</template>
				</div>
			</ManagingBox>
			<ManagingBox title="휴대폰 번호 강제 인증">
				<div class="info__phone-force-cert force-cert">
					<button
						v-if="!forceCertEnabled"
						class="force-cert__enable btn blue"
						@click="onForceCertEnable"
					>
						강제인증 하기
					</button>
					<template v-else>
						<input
							type="text"
							v-model="forceCertPhoneNumber"
							class="force-cert__input"
						/>
						<button
							class="force-cert__submit btn blue"
							@click="
								onForceCertSubmit(
									idRegister,
									forceCertPhoneNumber
								)
							"
						>
							강제인증
						</button>
						<button
							class="force-cert__cancel btn"
							@click="onForceCertDisable"
						>
							취소
						</button>
					</template>
				</div>
			</ManagingBox>
			<ManagingBox title="댓글 입력">
				<MemoBox ref-type="register" :ref-id="Number(idRegister)" />
			</ManagingBox>
		</ManagingSection>
	</article>
</template>
<script>
	import moment from 'moment';
	import util from '@/util';
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import RadioList from '@/components/RadioList';
	import RegisterEtcInfo from '@/components/register/RegisterEtcInfo.vue';
	import ProfileImg from '@/components/ProfileImg.vue';
	import MemoBox from '@/components/MemoBox.vue';
	import IsCertification from '@/components/Atoms/IsCertification';
	import PhoneNumber from '@/components/Atoms/PhoneNumber';
	import { beautyProfileTypeList } from '@/constants.js';
	import { beautyProfileTitleFromIdList, getShortUrl } from '@/util.js';

	export default {
		name: 'RegisterInfo',
		components: {
			ManagingSection,
			ManagingBox,
			RadioList,
			RegisterEtcInfo,
			ProfileImg,
			MemoBox,
			IsCertification,
			PhoneNumber,
		},
		data() {
			return {
				loading: false,
				idRegister: '',
				isBlindList: [
					{ id: 0, name: '블라인드 아님' },
					{ id: 1, name: '수동 블라인드' },
					{ id: 2, name: '자동 블라인드' },
				],
				isPickpleList: [
					{ id: true, value: 'Y' },
					{ id: false, value: 'N' },
				],
				isPickple: 'true',
				sameRegistersTotal: 0,
				sameRegisters: [],
				eventList: [],
				pwInitShortUrl: '',
				pwInitCreated: '',
				pwInitEnd: '',
				emailModifyActive: false,
				emailInput: '',
				registerStatus: '',
				info: {
					grade: 0,
					isBlind: 0,
				},
				eventWinTotal: 0,
				eventTotal: 0,
				forceCertPhoneNumber: '',
				forceCertEnabled: false,
				instaStatus: '',
				instaUrl: '',
				instaCate: '',
				instaId: '',
				hasInsta: false,
				// 임시코드
				insta: '',
				// 임시코드
				beautyProfileTypeList,
				beautyProfileTitleFromIdList,
			};
		},
		computed: {
			...mapState({
				adminImgUrl: state => state.env.adminImgUrl,
				gradeList: state => state.filter.gradeList,
				glowpickDomain: state => state.env.glowpickDomain,
			}),
			...mapGetters({
				getItemById: 'getItemById',
				hasAuthority: 'register/hasAuthority',
			}),
			getFcmToken() {
				if (!this.info) return '';
				const fcmToken = this.info.fcmToken;
				return fcmToken
					? `OS종류 : ${fcmToken.os} / OS버전 : ${fcmToken.osVersion} / 앱버전 : ${fcmToken.appVersion} / 디바이스 모델 : ${fcmToken.deviceModel}`
					: '';
			},
			age() {
				const { birthYear, birthMonth, birthDay, age } = this.info;
				return birthYear
					? `${birthYear}년 ${birthMonth}월 ${birthDay}일 (${age}세)`
					: '';
			},
		},
		created() {
			this.idRegister = this.$route.params.idRegister;
		},
		mounted() {
			if (!this.idRegister) return;
			this.initData();
		},
		methods: {
			async changeGrade({ id, lastId }) {
				try {
					if (!confirm('회원등급을 변경하겠습니까?')) {
						await this.$nextTick();
						this.info.grade = lastId;
						return;
					}
					const params = {
						idRegister: this.idRegister,
						grade: id,
					};
					await this.$axiosAdmin2.put(`/api/registers/grade`, params);
				} catch (err) {
					console.error(err);
					alert(
						'블랙리스트 상태 변경 에러입니다. 개발팀에 문의하세요.'
					);
				}
			},
			async changeIsBlind({ id, lastId }) {
				try {
					if (!confirm('블라인드 상태를 수정하겠습니까?')) {
						await this.$nextTick();
						this.info.isBlind = lastId;
						return;
					}
					const params = {
						idRegister: this.idRegister,
						isBlind: id,
					};
					await this.$axiosAdmin2.put(`/api/registers/blind`, params);
				} catch (err) {
					console.error(err);
					alert(
						'블라인드 상태 변경 에러입니다. 개발팀에 문의하세요.'
					);
				}
			},
			showOriginImg(path) {
				if (!path) return;
				util.popupImages([path]);
			},
			toggleSameRegisterModal() {
				this.$store.commit('modal/toggleModal', {
					id: 'RegisterSimpleList',
					params: this.sameRegisters,
				});
			},
			async getStatus() {
				const { data } = await this.$axiosAdmin2.get(
					`/api/registers/${this.idRegister}/status`
				);
				this.registerStatus = data.data.title;
			},
			setInstaInfo(exAd) {
				// 임시 코드
				if (this.$store.state.env.NODE_ENV === 'production') {
					if (!exAd || exAd.type !== 'instagram') {
						this.instaId = '';
						this.hasInsta = false;
						this.insta = '';
						this.originInsta = '';
						this.instaCate = '';
						return;
					}
					const { url, category } = exAd.doc.instagram;
					this.instaId = exAd.id;
					this.hasInsta = true;
					this.insta = url;
					this.originInsta = url;
					this.instaCate = category;
				} else {
					this.instaStatus = '미연동';
					this.instaUrl = '';
					this.instaCate = '';
					this.instaId = '';
					this.hasInsta = false;

					if (exAd && exAd.type === 'instagram') {
						// 인스타 아이디가 있는 경우
						const { url, category } = exAd.doc.instagram;
						this.instaStatus = '연동';
						this.instaUrl = url;
						this.instaCate = category;
						this.instaId = exAd.id;
						this.hasInsta = true;
					}
				}
				// 임시 코드
			},
			async getInfo() {
				const { data } = await this.$axiosAdmin2.get(
					`/api/registers/${this.idRegister}/info`
				);
				const res = (this.info = data.data);
				this.info.beautyProfileList = (
					this.info.beautyProfileList || []
				).map(item => item.id);
				this.info.reportedReviewsTotal =
					res.reportedReviews && res.reportedReviews.contentTotal;
				this.info.profileImgSrc =
					res.fileDir && res.fileSaveName
						? `${this.adminImgUrl}${res.fileDir}/${res.fileSaveName}`
						: '';
				this.info.gender = res.gender
					? this.getItemById('gender', res.gender).name
					: '';
				this.info.skinType = res.skinType
					? this.getItemById('skinType', res.skinType).name
					: '';
				this.forceCertPhoneNumber = res.userTel;
				this.setInstaInfo(data.data.externalAdvertising);
			},
			async getSameRegisters() {
				const { data } = await this.$axiosAuth.get(
					`/admin/register/${this.idRegister}/login_device_log`
				);
				const sameList = data.login_device_logs.reduce((acc, cur) => {
					if (
						acc.every(item => item.register_id !== cur.register_id)
					) {
						acc.push(cur);
					}
					return acc;
				}, []);
				this.sameRegistersTotal = sameList.length;
				this.sameRegisters = sameList.map((item, idx) => {
					return {
						id: item.register_id,
						title: `${idx + 1}. [${item.register_id}] ${item.nickName}`,
						href: `/register/register-info/${item.register_id}`,
					};
				});
			},
			async getEventList() {
				try {
					const { data } = await this.$axiosAdmin2.get(
						`/api/registers/${this.idRegister}/events`
					);
					this.eventWinTotal = ` Total ${data.winCount} / 신 ${data.newEventWinCount} / 구 ${data.oldEventWinCount}`;
					this.eventTotal = data.contentTotal;
					this.eventList = data.data.map(item => {
						return {
							cancelEvent: item.cancelEvent,
							boardTitle: item.boardTitle,
							brandTitle: item.brandTitle,
							startDate: item.startDate
								? item.startDate.split(' ')
								: ['', ''],
							createDate: item.createDate
								? item.createDate.split(' ')
								: ['', ''],
							idAdminBoard: item.idAdminBoard,
							isWin: item.isWin,
							idOldEvent: item.isOldEvent ? '구' : '신',
						};
					});
				} catch (err) {
					console.error(err);
					alert('이벤트 목록을 불러오는데 실패했습니다');
				}
			},
			async initData() {
				try {
					await Promise.all([
						this.getStatus(),
						this.getInfo(),
						this.getSameRegisters(),
						this.getEventList(),
					]);
				} catch (err) {
					console.error(err);
				}
			},
			async createdPWInitUrl() {
				try {
					const { data } = await this.$axiosAuth.get(
						`/admin/register/${this.idRegister}/reset-password`
					);
					const resetData = data.reset_password;
					this.pwInitShortUrl = await getShortUrl(
						`${this.glowpickDomain}/password/${resetData.uuid}`
					);
					this.pwInitCreated = moment(resetData.created_at).format(
						'YYYY-MM-DD HH:mm:SS'
					);
					this.pwInitEnd = moment(resetData.end_at).format(
						'YYYY-MM-DD HH:mm:SS'
					);
				} catch (err) {
					console.error(err);
				}
			},
			async cancelEvent(idEvent) {
				try {
					const { data } = await this.$axiosAdmin2.delete(
						`/api/registers/${Number(this.idRegister)}/event/${idEvent}`
					);
					if (!data.deleted) throw `data.deleted = ${data.deleted}`;
					this.getEventList();
				} catch (err) {
					console.error(err);
					alert(
						'이벤트를 취소하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			async changeEmail(isModify) {
				if (!isModify) {
					this.emailInput = this.info.email;
					this.emailModifyActive = !this.emailModifyActive;
					return;
				}
				try {
					await this.$axiosAuth.put(
						`/admin/register/${this.idRegister}/email`,
						{
							email: this.emailInput,
						}
					);
					this.emailModifyActive = !this.emailModifyActive;
					this.info.email = this.emailInput;
				} catch (err) {
					console.error(err);
					let msg = '이메일 변경에 실패 했습니다.';
					if (err.response.data.error.message) {
						msg += ` ${err.response.data.error.message}`;
					}
					alert(msg);
				}
			},
			showNicknameHistory() {
				this.$store.commit('modal/toggleModal', {
					id: 'ShowHistory',
					contsTitle: '닉네임 변경이력',
					params: {
						refId: this.idRegister,
						type: '프로필',
						keyList: ['nickName'],
					},
				});
			},
			showInstaHistory() {
				this.$store.commit('modal/toggleModal', {
					id: 'ShowHistory',
					contsTitle: '인스타그램 변경이력',
					params: {
						refId: this.idRegister,
						type: 'instagram',
						keyList: ['url'],
					},
				});
			},
			showAddProfileHistory() {
				this.$store.commit('modal/toggleModal', {
					id: 'ShowHistory',
					contsTitle: '프로필 추가정보 변경이력',
					params: {
						refId: this.idRegister,
						type: '연락처',
						keyList: [
							'userName',
							'userTel',
							'userZipcode',
							'userAddress',
							'userAddressMore',
						],
					},
				});
			},
			onForceCertEnable() {
				this.forceCertEnabled = true;
			},
			onForceCertDisable() {
				this.forceCertEnabled = false;
			},
			async checkForceCertNumberDuplication(phone) {
				const { data } = await this.$axiosAdmin2.get(
					`/api/registers/mobile-certification/${phone}`
				);
				return data.isCertification;
			},
			async onForceCertSubmit(idRegister, phone) {
				const checkRes =
					await this.checkForceCertNumberDuplication(phone);

				if (
					checkRes &&
					!confirm(
						'해당 휴대폰 번호로 인증받은 회원이 존재합니다.\n\n다른 계정의 휴대폰 번호 인증을 해제하고 현재 계정으로 강제 인증 하시겠습니까?'
					)
				) {
					this.onForceCertDisable();
					return false;
				}

				try {
					const { data } = await this.$axiosAdmin2.post(
						`/api/registers/${idRegister}/mobile-certification`,
						{
							phone,
						}
					);
				} catch (err) {
					console.error(err.response.data);
					const errorCode = `[${err.response.status}] ${err.response.data.message}`;
					alert(
						`강제인증 도중 에러가 발생했습니다.\n문제가 반복될 경우 개발팀에 문의하세요\n\nError Code: ${errorCode}`
					);
				} finally {
					this.onForceCertDisable();
					await this.initData();
				}
			},
			async changeIsPickple({ id, lastId }) {
				if (!confirm('픽플 여부를 변경하시겠습니까?')) {
					await this.$nextTick();
					this.info.isPickple = lastId;
					return;
				}
				try {
					const params = {
						isPickple: Boolean(id),
					};

					await this.$axiosAdmin2.put(
						`/api/registers/${this.idRegister}/pickple`,
						params
					);
				} catch (error) {
					alert('픽플 여부 변경에 실패했습니다.');
					console.error(error);
				}
			},
			async instaCateInput(instaCate) {
				const origin = this.instaCate;
				this.instaCate = instaCate;
				if (!confirm('인스타그램 카테고리를 변경하시겠습니까?')) {
					await this.$nextTick();
					this.instaCate = origin;
					return;
				}
				try {
					// 임시 코드
					if (this.$store.state.env.NODE_ENV === 'production') {
						await this.reqInsta({
							url: this.originInsta,
							category: instaCate,
						});
					} else {
						const method = this.hasInsta ? 'put' : 'post';
						const params = {
							type: 'instagram',
							doc: {
								instagram: {
									url: this.instaUrl,
									category: instaCate,
								},
							},
						};
						let path = `/api/registers/${this.idRegister}/external-advertising`;
						if (this.hasInsta) path += `/${this.instaId}`;
						await this.$axiosAdmin2[method](path, params);
					}
					// 임시 코드
					alert('인스타 카테고리 변경 성공!');
				} catch (err) {
					console.error(err);
					alert('인스타 카테고리 변경 실패!');
				} finally {
					this.initData();
				}
			},
			// 임시 코드
			async reqInsta(instaObj) {
				const method = this.hasInsta ? 'put' : 'post';
				const params = {
					type: 'instagram',
					doc: {
						instagram: instaObj,
					},
				};
				let path = `/api/registers/${this.idRegister}/external-advertising`;
				if (this.hasInsta) path += `/${this.instaId}`;
				await this.$axiosAdmin2[method](path, params);
			},
			async instaInput() {
				const txt = this.hasInsta ? '수정' : '입력';
				if (!confirm(`인스타 주소 ${txt} 합니까?`)) return;
				try {
					await this.reqInsta({
						url: this.insta,
						category: this.hasInsta ? this.instaCate : 'default',
					});
					alert(`인스타 주소 ${txt} 성공!`);
				} catch (err) {
					console.error(err);
					alert(`인스타 주소 ${txt} 실패!`);
				} finally {
					this.initData();
				}
			},
			async instaDelete() {
				if (!confirm('인스타 주소 삭제 합니까?')) return;
				try {
					await this.$axiosAdmin2.delete(
						`/api/registers/${this.idRegister}/external-advertising/${this.instaId}`
					);
					alert('인스타 주소 삭제 성공!');
				} catch (err) {
					console.error(err);
					alert('인스타 주소 삭제 실패!');
				} finally {
					this.initData();
				}
			},
			// 임시 코드
		},
	};
</script>
<style lang="scss" scoped>
	.general-tab {
		&#general-tab {
			border-color: unset !important;
			background-color: unset !important;
		}

		&__insta-url {
			margin-left: 12px;
		}

		// 임시 코드
		&__insta-wrapper {
			display: flex;
			flex-wrap: wrap;
		}

		&__insta-input {
			width: 400px;
		}

		&__insta-button {
			margin-left: 12px;
		}

		&__insta-desc {
			width: 100%;
			margin: 12px 0 0 0;
		}

		// 임시 코드
	}

	.info__profile {
		cursor: pointer;
	}

	.info__profile__img {
		vertical-align: middle;
	}

	.info__profile__name {
		display: inline-block;
		margin-left: 8px;
	}

	.info__email {
		width: 100%;
	}

	.info__email__text {
		display: inline-block;
	}

	.info__email__change-btn {
		vertical-align: middle;
	}

	.info__table__scroller {
		width: 100%;
		overflow-y: auto;
		max-height: 500px;
		border: solid 1px #dfe6ee;
	}

	.info__table {
		margin: 0;

		th {
			border-top: none;
		}

		th:first-child,
		td:first-child {
			border-left: none;
		}

		th:last-child,
		td:last-child {
			border-right: none;
		}
	}

	.info__event-win-icon--win {
		color: $green;
		font-weight: 700;
	}

	.info__event-win-icon {
		color: $red;
		font-weight: 700;
	}

	.info__table-cancel-btn {
		margin: 0 auto;
	}

	.info__pw-init {
		display: flex;
		align-items: center;
	}

	.info__pw-init-info {
		margin-left: 16px;
		font-size: 1rem;
	}

	.info__btn-nickname-history {
		margin-left: 12px;
		vertical-align: middle;
	}

	.info__btn-insta-history {
		margin-left: 12px;
		vertical-align: middle;
	}

	TABLE.info__add-profile-table {
		table-layout: fixed;

		tr {
			height: auto;
		}

		th,
		td {
			width: auto;
			padding: 12px;
		}

		.info__add-profile-table__btn-cell {
			width: 92px;
			padding-left: 0;
			padding-right: 0;
			text-align: center;
		}

		.info__add-profile-table__is-cert {
			display: flex;
			gap: 0.5em;
			align-items: center;
		}
	}

	.force-cert {
		display: flex;
		align-items: center;
		gap: 0.5em;
	}
</style>
